export default function HomePage() {
  return (
    <div
      style={{
        display: 'flex',
        height: '100dvh',
        flexDirection: 'column',
      }}
    >
      <h1>Hello there, Welcome to certificate 👋</h1>
    </div>
  );
}
